import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'
import { SjaFormComponent } from './sja-form.component';
import { SjaListComponent } from './components/sja-list.component';
import { SjaUserformComponent } from './components/sja-userform.component';
import { ConfirmationService } from 'primeng/api';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { SJAFormServices } from './sjaform.routing';
import { SJAFormListResolver, SJAFormResolver, SJATitleListResolver } from './sjaform.resolver.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorModule } from 'primeng/paginator';
import { AppSharedModule } from '../shared/appShared.module';

@NgModule({ declarations: [
        SjaListComponent,
        SjaFormComponent,
        SjaUserformComponent
    ],
  imports: [
    CommonModule,
    RouterModule,
    ConfirmDialogModule,
    TranslatePipe, TranslateDirective,
    TableModule,
    PaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    AppSharedModule
  ],
  providers: [
      ConfirmationService,
      SJAFormServices,
      SJAFormListResolver,
      SJAFormResolver,
      SJATitleListResolver,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class SjaFormModule { }
